module.exports = __webpack_public_path__ + "img/ais-bs.030a5246.svg";